import React, { useState } from "react";
import axios from "axios";
import "./FileUpload.css"; // Import the CSS file

//const herokuBackend = "http://localhost:5000"

const herokuBackend = "https://envoyuploader-56612abc1c6e.herokuapp.com"

function FileUpload( {user} ) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadedFileURLs, setUploadedFileURLs] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");

  const handleFileChange = (event) => {
    setSelectedFiles(Array.from(event.target.files));
    setUploadSuccess(false); // Reset upload success state when new files are selected
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const droppedFiles = Array.from(event.dataTransfer.files);
    setSelectedFiles(droppedFiles);
    setIsDragOver(false);
    setUploadSuccess(false); // Reset upload success state when new files are dropped
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleUpload = async () => {
    if (selectedFiles.length > 0) {
      setUploading(true);
      const formData = new FormData();

      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("files", selectedFiles[i]);
      }

      try {
        const response = await axios.post(`${herokuBackend}/upload?user=${user}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log(response.data);

        console.log("Files uploaded successfully");
        setUploadSuccess(true);
        setResponseMessage(response.data.message)
        setSelectedFiles([]);
        setUploadedFileURLs(response.data.fileURLs); // Capture URLs in state
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        setUploading(false);
      }
    }
  };

  return (
    <div>
      <div
        className={`drop-zone ${isDragOver ? "drag-over" : ""}`}
        onDragOver={handleDragEnter}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {selectedFiles.length > 0 ? (
          <ul>
            {selectedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        ) : (
          isDragOver ? "Drop files here" : "Drag and drop files here"
        )}
      </div>
      <input
        type="file"
        name="files"
        multiple
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload"}
      </button>
      {uploadSuccess && (
        <div className="success-alert">{responseMessage}</div>
      )}
      {uploadedFileURLs.length > 0 && (
        <div>
          <h2>Uploaded Files:</h2>
          <ul>
            {uploadedFileURLs.map((url, index) => (
              <li key={index}>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="uploaded-file-link" // Apply the class here
                >
                  {url}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default FileUpload;
